// product-model.js (fixed)
(() => {
  // Если кастом-элемент уже зарегистрирован — второй раз ничего не делаем
  if (customElements.get('product-model')) return;

  // ВАЖНО: класс объявлен внутри IIFE, не в глобальной области -> не будет "already been declared"
  class ProductModelEl extends DeferredMedia {
    constructor() { super(); }

    loadContent() {
      super.loadContent();
      Shopify.loadFeatures([
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: this.setupModelViewerUI.bind(this),
        },
      ]);
    }

    setupModelViewerUI(errors) {
      if (errors) return;

      const viewer = this.querySelector('model-viewer');
      if (!viewer) return;

      this.modelViewerUI = new Shopify.ModelViewerUI(viewer);

      const swiperEl = this.closest('.swiper');
      if (!swiperEl) return;

      const observer = new MutationObserver(() => {
        const swiper = swiperEl.swiper;
        if (!swiper) return;

        const disabled = viewer.classList.contains('shopify-model-viewer-ui__disabled');
        // когда UI активен — запрещаем свайп у слайдера, иначе разрешаем
        swiper.params.noSwiping = !disabled;
        swiper.params.noSwipingClass = 'swiper-slide';
      });

      observer.observe(viewer, { attributes: true });
    }
  }

  customElements.define('product-model', ProductModelEl);
})();

// XR-утилиты в отдельном неймспейсе, чтобы не пересекаться с именем класса
window.ProductModelXR = window.ProductModelXR || {
  loadShopifyXR() {
    Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXR.bind(this),
      },
    ]);
  },

  setupShopifyXR(errors) {
    if (errors) return;

    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', () => this.setupShopifyXR());
      return;
    }

    document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
      try {
        window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
      } catch (_) {}
      modelJSON.remove();
    });

    window.ShopifyXR.setupXRElements();
  },
};

// Автозагрузка XR
window.addEventListener('DOMContentLoaded', () => { window.ProductModelXR.loadShopifyXR(); });
